import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Col, Container, Form, Label, Row } from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../Utils/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { validationSchemaForUser } from "../UserManagement/Constant/valiadationshema";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import { createUser } from "../../slices/UserManagement/CreateUser/thunk";
import { updateUser } from "../../slices/UserManagement/UpdateUser/thunk";
import { getUserByName } from "../../slices/UserManagement/GetUserByName/thunk";
import { LabelText } from "../Utils/Input";
import OperatorProviderDetail from "./operatorProviderDetail";
import { validationSchemaForOperatorProfile } from "./validationSchemaForOperatorProfile";
import { countryOptionss, OperatorOptionsFields, OperatorStatusOptions } from "../OperatorManagement/Constant/Options";
import { fetchOperatorbyId } from "../../slices/OperatorManagement/GetOperatorbyID/thunk";
import moment from "moment";
import { editOperator } from "../../slices/OperatorManagement/EditOperator/thunk";
import {editBusinessProfile} from "../../slices/OperatorManagement/EditBusinessProfile/thunk"
import { validationSchema } from "../OperatorManagement/Constant/validationSchema";

export default function CreateOperatorProvider({ isEdit, handleImageUpload, initialValues, callState, roleName ,setProfileImage,profileImage}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const [editData, setEditData] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [fileSelected, setFileSelected] = useState(false);
    const changePassword = location?.state?.changePassword || false;
    const [changePasswordStatus, setChangePasswordStatus] = useState(false);
    const [loading, setLoading] = useState()
    const profile = location.pathname.includes('profile-operator')
    const operatorId = localStorage.getItem('operatorId')
    const profilee = []
    const [update, setUpdate] = useState(!!profilee);
    const [file, currentSelectedFile] = useState(null)
    return (
        <React.Fragment>
            <div id='csms' >
                <Formik
                    validationSchema={roleName != "systemUser" ? validationSchema : null}
                    initialValues={initialValues}
                    onSubmit={async (values) => {
                        if (roleName != "systemUser") {
                            if (
                                values?.firstname !== "" && values?.lastname !== "" && values?.email !== "" && values?.Status !== " " && values?.username !== " " && values?.userrole !== " " && values?.phone !== ""
                            ) {
                                const phoneNumber = formatPhoneNumberIntl(values?.phone)
                                let dialCodeWithPlus = phoneNumber.match(/^\+\d+(\s|$)/)[0];
                                let restOfNumber = phoneNumber.slice(dialCodeWithPlus?.length);
                                let mobileNumberWithoutSpaces = restOfNumber.replace(/\s/g, '');
                                let dialCodeWithoutSpaces = dialCodeWithPlus.replace(/\s/g, '');
                                const formattedValues = {
                                    tradingName: values.businessName,
                                    existsDuring: {
                                        endDateTime: values.endDate,
                                        // startDateTime: "2023-01-01T00:00:00Z"
                                    },
                                    domain: values.Domain?.value,
                                    state: values.state?.value,
                                    city: values.city?.value,
                                    country: values.country?.value,
                                    postcode: (values.zipCode).toString(),
                                    street1: values.Address,
                                    street2: values.Address2,
                                    // partyCharacteristic: values.attributeList,
                                    adminOperator:
                                    {
                                        userName: values.username,
                                        email: values.email,
                                        profile: {
                                            firstName: values.firstname,
                                            lastName: values.lastname
                                        },
                                        dialCode: dialCodeWithoutSpaces,
                                        phone: mobileNumberWithoutSpaces,
                                        isSSOUser: values.isSSOUser
                                    }
                                    ,
                                    ...(isEdit ? { status: values.Status?.value } : {})
                                };
                                if (!isEdit) {
                                    dispatch(createUser(formattedValues, setLoading, navigate));
                                } else {
                                    dispatch(editBusinessProfile(formattedValues, operatorId, setLoading, navigate,setEditData));
                                    if (file) {
                                        handleImageUpload(file)
                                    }
                                }
                            }
                        }
                        else {
                            if (file) {
                                handleImageUpload(file)
                            }
                        }
                    }}
                >
                    {({ handleChange, handleBlur, handleSubmit, errors, touched, values, setFieldValue, setFieldTouched }) => (

                        <Form className='needs-validation' onSubmit={handleSubmit}>
                            <Container fluid>
                                <ToastContainer position='top-center' />
                                <Row>
                                    {loading && (<Loader />)}
                                    <Col lg={12}>
                                        <div >
                                            <OperatorProviderDetail values={values} errors={errors} touched={touched} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} handleBlur={handleBlur} handleChange={handleChange} isEdit={isEdit} navigate={navigate} dispatch={dispatch} setLoading={setLoading} changePassword={changePassword} profile={profile} setChangePasswordStatus={setChangePasswordStatus} handleImageUpload={handleImageUpload} callState={callState} roleName={roleName} currentSelectedFile={currentSelectedFile} profileImage={profileImage} setProfileImage={setProfileImage}/>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}